module.exports = "<div class=\"error-message\" *ngIf=\"errormessage.show\" [ngStyle]=\"{'background-color': bgStyle}\" [@fadeInOut]>\r\n    <a class=\"close\" (click)=\"closeModal()\"><span>&times;</span></a>\r\n    <p>{{errormessage.message}}</p>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/error-message/error-message.component.html
// module id = ./src/app/shared/components/error-message/error-message.component.html
// module chunks = main